import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as actions from '../../Actions';

import { persistor } from '../../Store';

import Home from "../../Home";


class Logout extends Component {


    componentDidMount() {

        this.logout();

    }


    logout = () => {
        console.log('logout');

        this.props.userLogout();
        this.props.tokenRelease();
        this.props.refreshRelease();

        persistor.purge();
    }


    render() {

        return (
            <Home />
            );

    };

}


const mapStateToProps = (state) => ({
    auth: state.auth_reducer
});

export default connect(mapStateToProps, actions)(Logout);



// WEBPACK FOOTER //
// ./src/containers/Header/Logout.js